import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs';

const SWIPER_OPTIONS = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  observer: true,
  observeParents: true,
  mousewheel: {
    forceToAxis: true,
    releaseOnEdges: true,
  },
};

class CartRecommendedProductsSwiper extends HTMLElement {
  #swiper;

  #justConnected = false;

  connectedCallback() {
    if (this.#swiper) return;
    this.#initSwiper();
    this.#justConnected = true;
    queueMicrotask(() => {
      this.#justConnected = false;
    });
  }


  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = undefined;
  }

  #initSwiper() {
    this.#swiper = new Swiper(this, SWIPER_OPTIONS);
  }

  reinit() {
    if (this.#justConnected) return;
    this.#swiper?.destroy(true, true);
    this.#initSwiper();
  }
}

if (!customElements.get('cart-recommended-products-swiper')) {
  customElements.define('cart-recommended-products-swiper', CartRecommendedProductsSwiper);
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target instanceof Element ? event.target : document;
  root.querySelectorAll('cart-recommended-products-swiper').forEach((element) => {
    if (element instanceof CartRecommendedProductsSwiper) element.reinit();
  });
});
